<template>
  <PersonalLayout>
    <template v-slot:header>
      <AppHeader />
    </template>
    <template v-slot:side>
      <router-link to="/personal-objects" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 7L12 3L4 7M20 7L12 11M20 7V17L12 21M12 11L4 7M12 11V21M4 7V17L12 21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои объекты') }}</span>
      </router-link>
      <router-link to="/my-fonts" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M4 7V4H20V7M9 20H15M12 4V20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Мои шрифты') }}</span>
      </router-link>
      <div class="side-slide active">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('ИИ обработки') }}</span>
      </div>
      <router-link to="/personal-subscription" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M21 4H3C1.89543 4 1 4.89543 1 6V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V6C23 4.89543 22.1046 4 21 4Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M1 10H23" stroke="currentColor" stroke-width="2"/></svg>
        <span>{{ $t('Подписка') }}</span>
      </router-link>
      <router-link to="/personal-account" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Аккаунт') }}</span>
      </router-link>
      <router-link to="/personal-security" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Безопасность') }}</span>
      </router-link>
      <router-link v-if="isAdmin" to="/admin" class="side-slide">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M12 15C15.866 15 19 11.866 19 8C19 4.13401 15.866 1 12 1C8.13401 1 5 4.13401 5 8C5 11.866 8.13401 15 12 15Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21 13.89L7 23L12 20L17 23L15.79 13.88" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Панель администратора') }}</span>
      </router-link>
      <div class="side-slide logout-slide" @click="handleLogout">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        <span>{{ $t('Выйти') }}</span>
      </div>
    </template>
    <template v-slot:content>
      <div class="content-block">
        <div class="page-header">
          <div class="header-left">
            <h1>{{ $t('Мои обработки') }}</h1>
            <p class="page-description">{{ $t('Результаты ИИ-обработки ваших изображений') }}</p>
          </div>
          <div class="header-right">
            <div class="credits-info" v-if="credits !== null">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ credits }} {{ $t('кредитов') }}</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <p>{{ $t('Загрузка...') }}</p>
      </div>

      <div v-else-if="jobs.length === 0" class="empty-state">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="#ccc" stroke-width="2"/>
          <circle cx="8.5" cy="8.5" r="1.5" fill="#ccc"/>
          <polyline points="21,15 16,10 5,21" stroke="#ccc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <p>{{ $t('У вас пока нет обработанных изображений') }}</p>
        <p class="empty-hint">{{ $t('Обработайте первое изображение в редакторе, нажав "ИИ обработка"') }}</p>
      </div>

      <template v-else>
        <div class="jobs-grid">
          <div 
            v-for="job in jobs" 
            :key="job.id" 
            class="job-card"
            :class="{ 
              'processing': job.status === 'pending' || job.status === 'processing',
              'failed': job.status === 'failed'
            }"
          >
            <div class="job-image">
              <template v-if="job.status === 'completed' && job.output_image_url">
                <img :src="job.output_image_url" :alt="$t('Обработка #') + job.id" />
              </template>
              <template v-else-if="job.status === 'pending' || job.status === 'processing'">
                <div class="processing-overlay">
                  <div class="spinner"></div>
                  <span>{{ job.status === 'pending' ? $t('В очереди...') : $t('Обрабатывается...') }}</span>
                </div>
              </template>
              <template v-else-if="job.status === 'failed'">
                <div class="failed-overlay">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="#e53e3e" stroke-width="2"/>
                    <line x1="15" y1="9" x2="9" y2="15" stroke="#e53e3e" stroke-width="2" stroke-linecap="round"/>
                    <line x1="9" y1="9" x2="15" y2="15" stroke="#e53e3e" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  <span>{{ $t('Ошибка') }}</span>
                </div>
              </template>
              
              <button 
                v-if="job.status === 'completed' || job.status === 'failed'"
                class="delete-btn" 
                @click.stop="deleteJob(job.id)"
                :title="$t('Удалить')"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            
            <div class="job-info">
              <div class="job-title">
                 {{ job.zone_title || ($t('Обработка #') + job.id) }}
              </div>
              <div class="job-date">
                {{ formatDate(job.created_at) }}
              </div>
              <div class="job-status" :class="job.status">
                {{ getStatusText(job.status) }}
              </div>
              
              <div v-if="job.status === 'failed' && job.error_message" class="job-error">
                {{ job.error_message }}
              </div>
              
              <div v-if="job.status === 'completed'" class="job-actions">
                <button class="download-btn" @click="downloadImage(job)">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M21 15V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <polyline points="7,10 12,15 17,10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ $t('Скачать') }}
                </button>
                <button 
                  v-if="job.input_image_url" 
                  class="original-btn" 
                  @click="downloadOriginal(job)"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor" stroke-width="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor"/>
                    <polyline points="21,15 16,10 5,21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                   {{ $t('Оригинал') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </PersonalLayout>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue';
import PersonalLayout from '@/layout/PersonalLayout.vue';
import { getAiJobs, deleteAiJob, getCredits } from '@/api/credits';
import { useToast } from 'vue-toastification';

export default {
  name: 'MyProcessingsPage',
  components: {
    AppHeader,
    PersonalLayout,
  },
  data() {
    return {
      jobs: [],
      credits: null,
      loading: true,
      pollingInterval: null,
      toast: null,
      isMobile: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters['subscription/isAdmin'];
    },
  },
  created() {
    this.toast = useToast();
  },
  async mounted() {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 1024;
    await this.migrateImages();
    await this.loadData();
    this.startPolling();
  },
  beforeUnmount() {
    this.stopPolling();
  },
  methods: {
    async handleLogout() {
      await this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
    async migrateImages() {
      try {
        const token = localStorage.getItem('userToken');
        const response = await fetch('/api/ai/migrate-images', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        if (response.ok) {
          const data = await response.json();
          if (data.migrated > 0) {
            console.log(`Migrated ${data.migrated} images`);
          }
        }
      } catch (error) {
        console.error('Migration error:', error);
      }
    },
    async loadData() {
      try {
        const [jobsData, creditsData] = await Promise.all([
          getAiJobs(),
          getCredits()
        ]);
        this.jobs = jobsData.jobs || [];
        this.credits = creditsData.credits;
      } catch (error) {
        console.error('Error loading data:', error);
        this.toast.error(this.$t('Ошибка загрузки данных'));
      } finally {
        this.loading = false;
      }
    },
    startPolling() {
      this.pollingInterval = setInterval(async () => {
        const hasPendingJobs = this.jobs.some(
          j => j.status === 'pending' || j.status === 'processing'
        );
        if (hasPendingJobs) {
          try {
            const jobsData = await getAiJobs();
            this.jobs = jobsData.jobs || [];
          } catch (error) {
            console.error('Polling error:', error);
          }
        }
      }, 5000);
    },
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return this.$formatDate(date, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getStatusText(status) {
        const statusMap = {
         'pending': this.$t('processing.pending'),
         'processing': this.$t('processing.processing'),
         'completed': this.$t('processing.completed'),
         'failed': this.$t('processing.failed')
      };
      return statusMap[status] || status;
    },
    async downloadImage(job) {
      if (!job.output_image_url) return;
      
      if (this.isMobile) {
        window.open(job.output_image_url, '_blank');
        return;
      }
      
      try {
        const response = await fetch(job.output_image_url);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `ai-processed-${job.id}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.toast.success(this.$t('Изображение скачано'));
      } catch (error) {
        console.error('Download error:', error);
        this.toast.error(this.$t('Ошибка скачивания'));
      }
    },
    async downloadOriginal(job) {
      if (!job.input_image_url) return;
      
      if (this.isMobile) {
        window.open(job.input_image_url, '_blank');
        return;
      }
      
      try {
        const response = await fetch(job.input_image_url);
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `original-${job.id}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.toast.success(this.$t('Оригинал скачан'));
      } catch (error) {
        console.error('Download original error:', error);
        this.toast.error(this.$t('Ошибка скачивания оригинала'));
      }
    },
    async deleteJob(jobId) {
      if (!confirm(this.$t('processing.confirmDelete'))) return;
      
      try {
        await deleteAiJob(jobId);
        this.jobs = this.jobs.filter(j => j.id !== jobId);
        this.toast.success(this.$t('processing.deleted'));
      } catch (error) {
        console.error('Delete error:', error);
        this.toast.error(this.$t('errors.delete'));
      }
    }
  }
};
</script>

<style scoped>
.side-slide {
  display: block;
  padding: 10px;
  font-weight: 700;
  font-size: 16px;
  line-height: 120%;
  color: #1a1a1a;
  cursor: pointer;
  transition: all 0.2s;
  border-radius: 5px;
  border: 1px solid transparent;
  text-decoration: none;
}

.side-slide.active {
  border-color: #fafafa;
  box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.09);
  color: #1a1a1a;
}

.side-slide + .side-slide {
  margin-top: 5px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.header-left h1 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.page-description {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.credits-info {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  border-radius: 8px;
  color: #7c4a03;
  font-weight: 600;
  font-size: 14px;
}

.credits-info svg {
  color: #7c4a03;
}

.loading-state,
.empty-state {
  text-align: center;
  padding: 60px 20px;
  background: #fff;
  border-radius: 10px;
  margin: 10px 0;
}

.loading-state p,
.empty-state p {
  font-size: 16px;
  color: #666;
  margin: 16px 0 0 0;
}

.empty-state svg {
  margin-bottom: 16px;
}

.empty-hint {
  font-size: 14px !important;
  color: #999 !important;
  margin-top: 10px !important;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #eee;
  border-top-color: #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.jobs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  margin-top: 10px;
}

.job-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
}

.job-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.job-card.processing {
  border: 2px solid #667eea;
}

.job-card.failed {
  border: 2px solid #fed7d7;
}

.job-image {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.job-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.processing-overlay,
.failed-overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #666;
  font-size: 14px;
}

.processing-overlay .spinner {
  width: 32px;
  height: 32px;
}

.failed-overlay {
  color: #e53e3e;
}

.delete-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 32px;
  height: 32px;
  border: none;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s, background 0.2s;
  color: #666;
}

.job-card:hover .delete-btn {
  opacity: 1;
}

.delete-btn:hover {
  background: #fee;
  color: #e53e3e;
}

.job-info {
  padding: 16px;
}

.job-title {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.job-date {
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
}

.job-status {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
}

.job-status.pending,
.job-status.processing {
  background: #e8f4fd;
  color: #3182ce;
}

.job-status.completed {
  background: #c6f6d5;
  color: #276749;
}

.job-status.failed {
  background: #fed7d7;
  color: #c53030;
}

.job-error {
  margin-top: 8px;
  font-size: 12px;
  color: #c53030;
  background: #fff5f5;
  padding: 8px;
  border-radius: 4px;
}

.job-actions {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.download-btn,
.original-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.2s;
}

.download-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.original-btn {
  background: #f0f0f0;
  color: #555;
  border: 1px solid #ddd;
}

.download-btn:hover,
.original-btn:hover {
  opacity: 0.9;
}

.original-btn:hover {
  background: #e5e5e5;
}

.download-btn svg,
.original-btn svg {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 16px;
  }
  
  .jobs-grid {
    grid-template-columns: 1fr;
  }
  
  .job-card .delete-btn {
    opacity: 1;
  }
}
</style>
